import { configureStore } from '@reduxjs/toolkit'
import homeReducer from '../data/home/homeSlice'
import globalReducer from '../data/globalSlice'

export const store = configureStore({
    reducer: {
        home: homeReducer,
        global: globalReducer
    }
})